import {useMutation, useQueryClient} from '@tanstack/react-query';

import UniversityRepository, {UniversityFormRequest} from '../../../networking/repos/UniversityRepository';
import {UniversityQueryKey} from './Key';
import University from '../../../networking/models/University';

interface UniversityUpdateRequest {
    universityId: number;
    request: UniversityFormRequest;
}

export const useUniversityCreateMutation = () => {
    const queryClient = useQueryClient();
    const repo = new UniversityRepository();

    return useMutation({
        mutationFn: (request: UniversityFormRequest) => repo.create(request),
        onSuccess: (data) => queryClient.setQueryData(UniversityQueryKey.detail(data.id!), data)
    });
};

export const useUniversityUpdateMutation = () => {
    const queryClient = useQueryClient();
    const repo = new UniversityRepository();

    return useMutation({
        mutationFn: (request: UniversityUpdateRequest) => repo.update(request.universityId, request.request),
        onSuccess: (data) => queryClient.setQueryData(UniversityQueryKey.detail(data.id!), data)
    });
};

export const useUniversityDeleteMutation = () => {
    const queryClient = useQueryClient();
    const repo = new UniversityRepository();

    return useMutation({
        mutationFn: (id: number) => repo.destroy({ id } as University),
        onSuccess: (data, id) => queryClient.invalidateQueries(UniversityQueryKey.detail(id))
    });
};
